import { API } from "@/lib/api";

export function homePath(user) {
  if (!user) return "/login";
  if (user.platform_role === "super_admin") return "/platform";
  if (user.role === "customer") return "/portal";
  return "/dashboard";
}

export function logoSrc(user) {
  if (user?.business_logo) return `${API}/business/logo?v=${user.business_logo}`;
  return null;
}
